import { Component, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { IStore } from "@merchant_app/storage/store";
import { ActivatedRoute } from "@angular/router";
import * as WebhookActions from "@merchant_app/storage/webhook/webhook.actions";
import * as WebhookSelectors from "@merchant_app/storage/webhook/webhook.selectors";
import * as CurrentUserSelectors from "@merchant_app/storage/current-user/current-user.selectors";
import * as WebhooksSelectors from "@merchant_app/storage/webhooks/webhooks.selectors";
import * as WebhooksActions from "@merchant_app/storage/webhooks/webhooks.actions";
import { GoBackAction } from "@merchant_app/storage/router/router.actions";
import { CreateWebhookDto } from "@merchant_api/models/create-webhook-dto";
import { UpdateWebhookDto } from "@merchant_api/models/update-webhook-dto";

@Component({
    selector: "app-webhook",
    templateUrl: "./webhook.component.html",
    styleUrls: ["./webhook.component.less"],
    standalone: false
})
export class WebhookComponent implements OnInit {

    constructor(
        private store: Store<IStore>,
        private route: ActivatedRoute,
    ) {}

    webhook$ = this.store.select(WebhookSelectors.getWebhookInfo);
    lookups$ = this.store.select(WebhookSelectors.getWebhookLookups);
    loading$ = this.store.select(WebhookSelectors.getWebhookLoading);
    currentUser$ = this.store.select(CurrentUserSelectors.getCurrentUser);
    generatedSecret$ = this.store.select(WebhooksSelectors.getWebhooksSecret);
    generatedSecretLoading$ = this.store.select(WebhooksSelectors.getWebhooksSecretLoading);

    isCreate: boolean;

    ngOnInit() {

        this.store.dispatch(new WebhooksActions.ResetWebhooksSecretAction());

        this.isCreate = !this.route.snapshot.params.id;

        if (this.isCreate) {
            this.store.dispatch(new WebhookActions.GetNewWebhookAction());
        }
        else {
            this.store.dispatch(new WebhookActions.GetWebhookAction(this.route.snapshot.params.id));
        }
    }

    generateSecret() {

        this.store.dispatch(new WebhooksActions.GenerateWebhooksSecretAction());
    }

    updateWebhook(payload: {id: number; webhook: UpdateWebhookDto}) {

        this.store.dispatch(new WebhookActions.UpdateWebhookAction(payload.id, payload.webhook));
    }

    createWebhook(webhook: CreateWebhookDto) {

        this.store.dispatch(new WebhookActions.CreateWebhookAction(webhook));
    }

    deleteWebhook(webhookId: number) {

        this.store.dispatch(new WebhookActions.DeleteWebhookAction(webhookId));
    }

    onBack(): void {

        this.store.dispatch(GoBackAction());
    }

}
